mutation CancelAccountDeletion($targetAccountId: ID!) {
  result: StreamToolsCancelAccountDeletion(targetAccountId: $targetAccountId) {
    accountId
    status
    requestedAt
    runAt
    staffAccount
    scheduledAt
  }
}
